// Utilitário para aplicar máscaras em inputs
export const applyMask = (value, mask) => {
    if (!value || !mask) return value;

    const cleanValue = value.replace(/\D/g, ""); // Remove tudo que não é dígito
    let maskedValue = "";
    let valueIndex = 0;

    for (let i = 0; i < mask.length && valueIndex < cleanValue.length; i++) {
        if (mask[i] === "9") {
            maskedValue += cleanValue[valueIndex];
            valueIndex++;
        } else {
            maskedValue += mask[i];
        }
    }

    return maskedValue;
};

export const removeMask = (value) => {
    return value.replace(/\D/g, "");
};

// Máscaras específicas
export const applyCpfMask = (value) => {
    return applyMask(value, "999.999.999-99");
};

export const applyCnpjMask = (value) => {
    return applyMask(value, "99.999.999/9999-99");
};

export const applyCepMask = (value) => {
    return applyMask(value, "99999-999");
};

export const applyPhoneMask = (value) => {
    const cleanValue = removeMask(value);
    if (cleanValue.length <= 10) {
        return applyMask(value, "(99) 9999-9999");
    } else {
        return applyMask(value, "(99) 99999-9999");
    }
};

// Hook personalizado para usar com inputs
export const useMaskedInput = (mask) => {
    const handleChange = (e, onChange) => {
        const { value } = e.target;
        const maskedValue =
            typeof mask === "function" ? mask(value) : applyMask(value, mask);

        // Atualiza o valor do input
        e.target.value = maskedValue;

        // Chama o onChange com o valor mascarado
        onChange(maskedValue);
    };

    return { handleChange };
};

export const mascCoin = (
    value,
    simbol = "R$",
    decimalPlaces = 2,
    decimalSeparator = ",",
    thousandSeparator = "."
) => {
    // Trata diferentes tipos de entrada
    let numValue;

    if (typeof value === "string") {
        // Se for string, substitui vírgula por ponto para interpretação decimal correta
        const valueWithDot = value.replace(",", ".");
        numValue = parseFloat(valueWithDot) || 0;
    } else {
        // Se for número, usa diretamente
        numValue = parseFloat(value) || 0;
    }

    // Formata o número com as casas decimais corretas
    const formattedValue = numValue.toFixed(decimalPlaces);

    // Divide entre parte inteira e decimal
    const parts = formattedValue.split(".");

    // Adiciona separador de milhares na parte inteira
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    // Monta o valor final com o símbolo da moeda
    return `${simbol} ${parts[0]}${decimalSeparator}${parts[1]}`;
};

export const mascPercent = (value, decimalSeparator = ",", decimalPlaces = 2) => {
    // Trata diferentes tipos de entrada
    let numValue;

    if (typeof value === "string") {
        // Se for string, substitui vírgula por ponto para interpretação decimal correta
        const valueWithDot = value.replace(",", ".");
        numValue = parseFloat(valueWithDot) || 0;
    } else {
        // Se for número, usa diretamente
        numValue = parseFloat(value) || 0;
    }

    // Formata o número com as casas decimais corretas
    const formattedValue = numValue.toFixed(decimalPlaces);

    // Substitui o ponto decimal pelo separador desejado
    const finalValue = formattedValue.replace(".", decimalSeparator);

    // Adiciona o símbolo de porcentagem
    return `${finalValue} %`;
}

export const formatTimeValue = (value) => {
    // Se o valor estiver vazio, nulo ou for 0
    if (!value || value === 0 || value === "0") return "00:00";

    // Se o valor for apenas um número (ex: "5"), converta para minutos (ex: "00:05")
    if (/^\d+$/.test(value)) {
        const num = parseInt(value, 10);
        if (num < 60) return `00:${num.toString().padStart(2, "0")}`;
        const hours = Math.floor(num / 60);
        const minutes = num % 60;
        return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
    }

    // Se já estiver no formato correto, retorne o valor
    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(value)) {
        // Certifique-se que horas e minutos tenham dois dígitos
        const parts = value.split(":");
        return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
    }

    // Caso contrário, retorne o formato padrão
    return "00:00";
};
